import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Card, IconButton, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import { StyledCardContent } from './ReusableUI'

/**
 * KPI / value tile for the dashboard.
 *
 * `isLoading` shows a subtle shimmer in place of the value so the tile
 * signals "still loading" instead of displaying a 0 that could be
 * confused with real zero-count data. See DashboardPage — this fires
 * while the background /search/all fetch is filling in after the fast
 * shell load.
 */
const StatCard = ({
  label,
  value,
  hint,
  isLoading = false,
}: {
  label: string
  value: number | string
  hint?: string
  isLoading?: boolean
}) => (
  <Card sx={{ borderRadius: 3, height: '100%' }}>
    <StyledCardContent>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography variant="overline" sx={{ opacity: 0.7, color: 'text.primary' }}>
          {label}
        </Typography>
        {hint && (
          <Tooltip title={hint}>
            <IconButton size="small">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      {isLoading ? (
        <Skeleton
          variant="text"
          width="60%"
          height={40}
          sx={{ mt: 0.5, borderRadius: 1 }}
          animation="wave"
        />
      ) : (
        <Typography variant="h4" sx={{ mt: 0.5, fontWeight: 700, color: 'text.primary' }}>
          {value}
        </Typography>
      )}
    </StyledCardContent>
  </Card>
)

export default StatCard
